import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { IIntegration } from '../../core/store/integrations/models/integrations';

@Injectable({
  providedIn: 'root',
})
export class IntegrationsService {
  private baseApiUrl: string = environment.API_BASE_URL;

  constructor(private readonly http: HttpClient) {}

  getIntegrations(): Observable<IIntegration[]> {
    return this.http.get<IIntegration[]>(`${this.baseApiUrl}/integrations`);
  }

  deleteIntegration(id: string): Observable<any> {
    return this.http.delete<any>(`${this.baseApiUrl}/integrations/remove`, {
      body: { id },
    });
  }
}
